import { Trans, useTranslation } from 'react-i18next';
import { MdSync } from 'react-icons/md';
import { HeroCard, StepCards, SupportEmailText } from '../../../components';
import { SUPPORT_EMAIL } from '../../../constants';
import * as S from '../../../styles';

const SyncingUntracked = () => {
  const [t] = useTranslation('calendar');

  const translatedSteps = t('syncing.untracked.steps', {
    returnObjects: true,
  });
  const steps = Array.isArray(translatedSteps) ? translatedSteps : [];

  return (
    <>
      <HeroCard compact icon={<MdSync />} title={t('syncing.untracked.title')}>
        <Trans
          i18nKey="syncing.untracked.description"
          ns="calendar"
          components={{ strong: <strong /> }}
        />
      </HeroCard>

      <S.SectionHeading>
        {t('syncing.untracked.steps-heading')}
      </S.SectionHeading>
      <StepCards compact steps={steps} />

      <S.Paragraph>
        <SupportEmailText
          i18nKey="syncing.untracked.support"
          email={SUPPORT_EMAIL}
        />
      </S.Paragraph>
    </>
  );
};

export default SyncingUntracked;
